/**
 * Turn thrown values and API error payloads into a safe user-visible string.
 * Avoids "[object Object]" when errors are plain objects (e.g. PostgrestError).
 */
export function formatErrorMessage(value, fallback = 'Something went wrong. Please try again.') {
  if (value == null || value === '') return fallback;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed || trimmed === '[object Object]') return fallback;
    return trimmed;
  }
  if (value instanceof Error) return value.message?.trim() || fallback;
  if (typeof value === 'object') {
    const msg = value.message ?? value.error ?? value.details ?? value.hint;
    if (typeof msg === 'string' && msg.trim()) return msg.trim();
    try {
      return JSON.stringify(value);
    } catch {
      return fallback;
    }
  }
  return String(value);
}
